import React from 'react';
import type { JoinRefusal } from '../../network/joinRefusal';
import { isGuestJwt } from '../../services/authToken';
import { storage } from '../../services/StorageService';
import { Button } from '../primitives/Button';
import { PLAYER_UI, playerPanel } from '../theme';

/** Leave the refused world. A guest's session ends here (its hero is
 * session-only), so the next screen offers sign-in or a fresh guest; an
 * account session is kept. */
export function leaveRefusedWorld(path: '/' | '/resume'): void {
  try {
    if (isGuestJwt(storage.get('helix_jwt'))) {
      storage.remove('helix_jwt');
      storage.remove('helix_last_character');
    }
  } catch { /* storage disabled — the navigation still leaves the world */ }
  window.location.assign(path);
}

/** Shown instead of "Connecting to the world…" when the server refused the
 * join (joinRefusal.ts): the client has stopped retrying. */
export const JoinRefusedScreen: React.FC<{ refusal: JoinRefusal }> = ({ refusal }) => (
  <div style={{ position: 'absolute', inset: 0, zIndex: 9999, display: 'grid', placeItems: 'center', overflow: 'auto', padding: 24, boxSizing: 'border-box', background: `radial-gradient(ellipse at 50% 30%,rgba(201,163,92,.1),transparent 60%),${PLAYER_UI.inkDeep}`, fontFamily: PLAYER_UI.bodyFont }}>
    <section role="alert" aria-label="Could not enter the world" data-join-refusal={refusal.code}
      style={{ ...playerPanel(), padding: 'clamp(24px,5vw,44px)', width: 'min(100%,460px)', boxSizing: 'border-box', textAlign: 'center' }}>
      <img src="/icons/abilities/word_of_shielding.svg" alt="" width={64} height={64} />
      <h1 style={{ fontFamily: PLAYER_UI.displayFont, fontWeight: 500, fontSize: 24, margin: '20px 0 12px', color: PLAYER_UI.text }}>{refusal.title}</h1>
      <p style={{ color: PLAYER_UI.secondary, fontSize: 14, lineHeight: 1.6, margin: '0 0 22px' }}>{refusal.message}</p>
      <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
        {refusal.offerPlayHere && (
          <Button variant="brass" size="lg" onClick={() => window.location.reload()}>Play here</Button>
        )}
        {refusal.offerSignIn && (
          <Button variant="brass" size="lg" onClick={() => leaveRefusedWorld('/resume')}>Sign in</Button>
        )}
        <Button variant={refusal.offerSignIn || refusal.offerPlayHere ? 'secondary' : 'brass'} size="lg"
          // The other window still plays this hero: keep a guest's session for it.
          onClick={() => (refusal.offerPlayHere ? window.location.assign('/') : leaveRefusedWorld('/'))}>Back to the menu</Button>
      </div>
    </section>
  </div>
);
